// extracted by css-extract-rspack-plugin
export default {"container":"mNqf7KH___container","tag-container":"K20xeV3___tag-container","tagContainer":"K20xeV3___tag-container"};